/**
 * Privacy Policy — public route. No PII collected here. Required by Apple Guideline 5.1.1
 * and Google Play Data Safety. Replace placeholders with company-specific data.
 */
export default function PrivacyPolicy() {
  return (
    <main className="max-w-3xl mx-auto px-6 py-10 prose prose-invert">
      <h1>Política de Privacidade — Neural Core OS</h1>
      <p><strong>Última atualização:</strong> 24/04/2026</p>

      <h2>1. Quem somos</h2>
      <p>Neural Core OS ("nós", "app") é operado por P2HM. Contato: <a href="mailto:privacy@p2hm.app">privacy@p2hm.app</a>.</p>

      <h2>2. Dados que coletamos</h2>
      <ul>
        <li><strong>Conta:</strong> e-mail, nome de exibição, avatar (opcional).</li>
        <li><strong>Conteúdo:</strong> mensagens de chat, dossiês de pesquisa, configurações de agentes.</li>
        <li><strong>Compras:</strong> histórico de transações via App Store / Play Store (sem dados de cartão).</li>
        <li><strong>Diagnóstico:</strong> crashes, performance e erros via Sentry (anônimo).</li>
        <li><strong>Uso:</strong> eventos agregados de produto via PostHog (sem PII).</li>
      </ul>

      <h2>3. Como usamos</h2>
      <p>Para autenticar, persistir suas conversas/dossiês, processar pagamentos, melhorar o produto e prevenir abuso.</p>

      <h2>4. Compartilhamento</h2>
      <p>Compartilhamos com sub-processadores: Supabase (banco), OpenAI/Google AI (inferência opcional, somente quando você dispara), RevenueCat (assinaturas), Sentry, PostHog, Apple/Google (push). Nenhum dado é vendido.</p>

      <h2>5. Retenção</h2>
      <p>Dados de conta enquanto a conta existir. Logs de auditoria 30 dias após exclusão.</p>

      <h2>6. Seus direitos</h2>
      <ul>
        <li>Exportar dados: Configurações → Exportar.</li>
        <li>Excluir conta + dados: Configurações → Excluir Conta (exclusão imediata, retenção legal de 30d).</li>
        <li>Revogar consentimento de tracking: Configurações → Privacidade.</li>
      </ul>

      <h2>7. Crianças</h2>
      <p>O app é classificado 4+. Não coletamos conscientemente dados de crianças menores de 13.</p>

      <h2>8. Alterações</h2>
      <p>Notificamos via app e e-mail antes de mudanças relevantes.</p>

      <h2>9. Contato DPO</h2>
      <p><a href="mailto:dpo@p2hm.app">dpo@p2hm.app</a></p>
    </main>
  );
}
